module.exports = __webpack_public_path__ + "img/residential_facilities.0649ebcb.svg";